module.exports = __webpack_public_path__ + "img/0-02-0a-39de21fa78cd09cd42242ebde641492531fb3d0e678099c72caea608a2f952f3_6fee5a28.51b30d8b.jpg";